import { createContext, useContext, useState, useEffect } from "react";

const SidebarContext = createContext({
  isCollapsed: false,
  setIsCollapsed: () => {},
  mainClass: "ml-0 md:ml-[240px] pt-14 md:pt-0"
});

export const SidebarProvider = ({ children }) => {
  const [isCollapsed, setIsCollapsed] = useState(() => {
    const saved = localStorage.getItem("dealforge_sidebar_collapsed");
    return saved === "true";
  });

  useEffect(() => {
    localStorage.setItem("dealforge_sidebar_collapsed", isCollapsed.toString());
  }, [isCollapsed]);

  // Mobile: no margin, padding for header. Desktop: sidebar margin
  const mainClass = isCollapsed 
    ? "ml-0 md:ml-[60px] pt-14 md:pt-0" 
    : "ml-0 md:ml-[240px] pt-14 md:pt-0";

  return (
    <SidebarContext.Provider value={{ isCollapsed, setIsCollapsed, mainClass }}>
      {children}
    </SidebarContext.Provider>
  );
};

export const useSidebar = () => useContext(SidebarContext);
